/**
 * Quick statistics grid for payment requests
 */
import { Card, CardContent } from '../ui/card';

const RequestStats = ({ pendingCount, completedCount, totalReceived, totalRequests }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="request-stats">
      <Card>
        <CardContent className="p-4 text-center">
          <p className="text-xs text-muted-foreground">Pending</p>
          <p className="text-2xl font-bold text-amber-500" data-testid="stat-pending">{pendingCount}</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4 text-center">
          <p className="text-xs text-muted-foreground">Completed</p>
          <p className="text-2xl font-bold text-emerald-500" data-testid="stat-completed">{completedCount}</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4 text-center">
          <p className="text-xs text-muted-foreground">Total Received</p>
          <p className="text-2xl font-bold" data-testid="stat-received">${totalReceived.toFixed(2)}</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4 text-center">
          <p className="text-xs text-muted-foreground">All Time</p>
          <p className="text-2xl font-bold" data-testid="stat-total">{totalRequests}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default RequestStats;
